import { render, staticRenderFns } from "./ValidacaoContracheque.vue?vue&type=template&id=3e56a206&scoped=true"
import script from "./ValidacaoContracheque.vue?vue&type=script&lang=js"
export * from "./ValidacaoContracheque.vue?vue&type=script&lang=js"
import style0 from "./ValidacaoContracheque.vue?vue&type=style&index=0&id=3e56a206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e56a206",
  null
  
)

export default component.exports